<div data-test="favorites-cta" class="favorites-cta-wrapper d-flex flex-column justify-content-center my-3 me-25 me-sm-0 p-lg-3 rounded bg-grey-300">
  <div *ngIf="cta.iconImage" class="justify-content-center rounded-circle m-auto bg-white p-2 mb-2 svg-vertical-align-middle d-lg-flex d-none">
    <flo-svg-icon icon="{{cta.iconImage.style}}" width="1.5em"></flo-svg-icon>
  </div>
  <h4 class="d-lg-block d-none text-center" *ngIf="cta.title">{{cta.title}}</h4>
  <p *ngIf="cta.subtitle" class="subhead text-center d-lg-block d-none">{{cta.subtitle}}</p>
  <flo-link class="btn-full-width" [link]="cta.action"></flo-link>
</div>
